import { flattenServiceResponse } from "./responseFlattener";

export function normalizeRuntimeResponse(
  payload,
  { locale = "ru", participantTypeCode, serviceCode } = {}
) {
  if (!payload) return [];

  if (process.env.NODE_ENV !== "production") {
    if (!participantTypeCode) {
      console.warn(
        "[normalizeRuntimeResponse] participant_type_code отсутствует — все поля будут отфильтрованы. serviceCode:",
        serviceCode
      );
    }
    if (!serviceCode) {
      console.warn(
        "[normalizeRuntimeResponse] service_code отсутствует — все поля будут отфильтрованы."
      );
    }
  }

  const flat = flattenServiceResponse(payload, {
    locale,
    structured: false,
  });

  return flat
    .map((item) => ({
      key: item.path,
      value: item.value,
      participant_type_code: participantTypeCode,
      service_code: serviceCode,
    }))
    .filter(
      (f) =>
        f.key &&
        f.value !== undefined &&
        f.value !== "" &&
        f.service_code &&
        f.participant_type_code
    );
}
